import actionTypes from '../constants/action-types';

const deleteFolder = (folderId) => ({
  type: actionTypes.DELETE_FOLDER,
  payload: {
    folderId,
  },
});

export default deleteFolder;
